<template>
  <b-input-group>
    <flat-pickr
      ref="flatpickr"
      :id="pickerId"
      :name="name"
      :value="value"
      :config="timeConfig"
      :disabled="disabled"
      :class="{ 'flat-pickr': true, 'form-control': true, 'border-right-0': true, ...withClass }"
      @input="onInput"
    />
    <b-input-group-append
      class="flatpickr-icon-container"
      :readonly="disabled"
      @click="openFlatpickr"
    >
      <i class="si si-clock" />
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import { DateTime } from 'luxon';
import { uniqueId as _uniqueId } from 'lodash';
import ConfirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate.js';

export default {
  name: 'TimePicker',
  props: {
    id: {
      type: String,
    },
    name: {
      type: String,
    },
    value: {
      type: String,
    },
    static: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    timeZone: {
      type: String,
      default: null,
    },
    withClass: {
      type: Object,
    },
  },
  data() {
    return {
      timeConfig: {
        wrap: false,
        allowInput: true,
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        altInput: true,
        altFormat: 'h:i K',
        static: this.static,
        plugins: [new ConfirmDatePlugin({
          confirmIcon: '<i class=\'fa fa-check ml-2\'></i>',
          confirmText: 'OK',
          showAlways: false,
          theme: 'light'
        })],
      },
      pickerId: this.id || `sfs-time-picker-${_uniqueId()}`,
    };
  },
  methods: {
    onInput(payload) {
      const v = Array.isArray(payload) ? payload[0] : payload;

      let hhmm;
      if (v instanceof Date) {
        hhmm = DateTime.fromJSDate(v).toFormat('HH:mm');
      } else if (typeof v === 'string' && v.trim() !== '') {
        hhmm = v;
      } else {
        hhmm = null;
      }

      this.$emit('input', hhmm);
    },
    openFlatpickr() {
      const fp = this.$refs.flatpickr?.fp;
      if (!this.disabled && fp && typeof fp.open === 'function') {
        if (this.value) {
          fp.setDate(this.value, false, 'H:i');
        }
        fp.open();
      }
    },
  },
};
</script>
